import { all } from "redux-saga/effects";
import authSagas from "./Auth";
import mailSagas from "./Mail";

export default function* rootSaga(getState) {
  yield all([mailSagas(), authSagas()]);
}
